import makeApiRequest from './makeApiRequest';

const putCloseFair = () => {
	const putApiRequest = makeApiRequest('PUT');

	const closeFair = async (apiBase: string) => putApiRequest(`${apiBase}/api/fair/close`, undefined);

	return [closeFair];
};

export default putCloseFair;
